import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/rules-of-hooks */
import * as React from 'react';
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { DeviceTypeMediaQuery } from '../../../internal/services';
import { useUiKitContext } from '../../../internal/context';

/**
 * Возвращает deviceType, используемый в Ui-Kit
 *
 * На сервере возвращает deviceType из контекста Ui-Kit
 *
 * Если в контексте стоит флаг useStaticDeviceType то всегда возвращает deviceType из контекста
 */
export function useDeviceType() {
  var _useUiKitContext = useUiKitContext(),
    staticDeviceType = _useUiKitContext.deviceType,
    useStaticDeviceType = _useUiKitContext.useStaticDeviceType;
  if (typeof window === 'undefined') {
    return staticDeviceType;
  }
  var mediaQuery = DeviceTypeMediaQuery.ensureSingleton();
  var _React$useState = React.useState(staticDeviceType),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    deviceType = _React$useState2[0],
    setDeviceType = _React$useState2[1];
  useIsomorphicLayoutEffect(function () {
    if (useStaticDeviceType) {
      if (deviceType !== staticDeviceType) {
        setDeviceType(staticDeviceType);
      }
    } else {
      var mediaDeviceType = mediaQuery.getDeviceType();
      if (mediaDeviceType && deviceType !== mediaDeviceType) {
        setDeviceType(mediaDeviceType);
      }
    }
  }, [useStaticDeviceType, staticDeviceType]);
  React.useEffect(function () {
    if (useStaticDeviceType) {
      return;
    }
    return mediaQuery.subscribe(function (value) {
      return setDeviceType(value || staticDeviceType);
    });
  }, [mediaQuery, staticDeviceType, useStaticDeviceType]);
  return deviceType;
}